import React, { useEffect, useState } from "react";
import "../css/GoTop.css";

function GoTop() {
  const [backToTopButton, setBackToTopButton] = useState(false);
  useEffect(() => {
    const onScroll = () => setBackToTopButton(window.scrollY > 900);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="goTopButton">
      {backToTopButton && <button onClick={scrollUp}>^</button>}
    </div>
  );
}
export default GoTop;
